import { Button } from '@totalsoft/rocket-ui';
import { Grid, styled } from '@mui/material';

export const CardButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginRight: theme.spacing(1),
  '&:disabled': {
    color: 'black'
  }
}));

export const GridfilledItemWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(1.25)
}));

export const DeleteIconButtonRoot = styled(Button, {
  shouldForwardProp: prop => !['deletionStatus'].includes(prop)
})(({ deletionStatus, theme }) => ({
  '&:hover': {
    color: theme.palette.warning.main,
    boxShadow: 'none',
    outline: 'none'
  },
  ...(deletionStatus && { color: theme.palette.warning.main })
}));
